import router from '@Src/router';
import type { App } from 'vue';

export function setupRouter(app: App) {
    app.use(router);
}
